import { IChartApi } from 'lightweight-charts';

export type CrosshairPriceLineElements = {
  line: HTMLDivElement;
  label: HTMLDivElement;
};

export const createCrosshairPriceLineElements =
  (): CrosshairPriceLineElements => {
    const line = document.createElement('div');
    line.style.position = 'absolute';
    line.style.width = '100%';
    line.style.height = '1px';
    line.style.left = '0';
    line.style.background =
      'repeating-linear-gradient(to right, rgba(117, 134, 150, 0.5) 0%, rgba(117, 134, 150, 0.5) 50%, transparent 50%, transparent 100%)';
    line.style.backgroundSize = '6px 1px';
    line.style.pointerEvents = 'none';
    line.style.display = 'none';
    line.style.zIndex = '1000';

    const label = document.createElement('div');
    label.style.position = 'absolute';
    label.style.right = '0';
    label.style.backgroundColor = 'rgba(51, 51, 51, 0.9)';
    label.style.color = 'white';
    label.style.padding = '2px 4px';
    label.style.fontSize = '12px';
    label.style.fontFamily = 'Helvetica, Arial, sans-serif';
    label.style.borderRadius = '2px';
    label.style.pointerEvents = 'none';
    label.style.display = 'none';
    label.style.zIndex = '1001';
    label.style.whiteSpace = 'nowrap';
    label.style.transform = 'translateY(-50%)';

    return { line, label };
  };

export const attachCrosshairPriceLineElements = (
  chart: IChartApi,
  elements: CrosshairPriceLineElements
) => {
  chart.chartElement().appendChild(elements.line);
  chart.chartElement().appendChild(elements.label);
};

export const removeCrosshairPriceLineElements = (
  chart: IChartApi,
  elements: CrosshairPriceLineElements
) => {
  chart.chartElement().removeChild(elements.line);
  chart.chartElement().removeChild(elements.label);
};

export const updateCrosshairPriceLine = (
  elements: CrosshairPriceLineElements,
  yPos: number | null,
  labelText?: string
) => {
  if (yPos !== null && labelText !== undefined) {
    elements.line.style.top = `${yPos}px`;
    elements.line.style.display = 'block';
    elements.label.style.top = `${yPos}px`;
    elements.label.textContent = labelText;
    elements.label.style.display = 'block';
  } else {
    elements.line.style.display = 'none';
    elements.label.style.display = 'none';
  }
};
